<action-box *ngIf="visible" textLeft="{{actionBoxTitle}}" [showHeader]="showHeader">
  <form-panel
                   [configurationId]="configurationId"
                   [panel]="form"
                   [id]="form.longId"
                   [showTitle]="false"
                   [view]="RequestViews.Summary"></form-panel>
</action-box>
